




















import { Component, Mixins } from "vue-property-decorator";
import { PropertyEditableMixin, DrawerPropertyEditableMixin, LineDrawerPropertyEditableMixin } from "./mixins";
import { DrawableItemEditorMixin } from "../mixins";
import LineStyleEditor from "../../../drawing/LineStyleEditor.vue";
import PrintBehaviorEditor from "./PrintBehaviorEditor.vue";

@Component({
  components: {
    lineStyleEditor: LineStyleEditor,
    printBehaviorEditor: PrintBehaviorEditor,
  },
})
export default class LinePropertyEditor extends Mixins(PropertyEditableMixin, DrawableItemEditorMixin, DrawerPropertyEditableMixin, LineDrawerPropertyEditableMixin) {
}
